import React, { Fragment, useState, useEffect } from "react";
import TextInput from "../../inputs/text-input";
import SelectFieldComboField from "../../inputs/select-field-combo/select-field-combo-field";
import updateArrangementsPrice from "module/functions/updateArrangementsPrice";
import updateArrangementsPriceWithoutDiscount from "module/functions/updateArrangementsPriceWithoutDiscount";
import updateArrangementsDiscount from "module/functions/updateArrangementsDiscount";
import MediaField from "./media-field";
import { translate } from "application/functions";

const Arrangement = (props) => {
  const {
    form,
    register,
    index,
    indexToShow,
    setSelectValue,
    errors,
    deleteItem,
    jPath,
    setArrangementsPrice,
    setArrangementsPriceWithoutDiscount,
    setArrangementsDiscount,
    optionsAllowed,
    setOnFocus,
    addItem,
    isLast,
    windowSize,
    isMobileBrowser,
    isHidden,
  } = props;

  const [price, setPrice] = useState([]);
  const [priceWithoutDiscount, setPriceWithoutDiscount] = useState([]);
  const [discount, setDiscount] = useState([]);
  const [options, setOptions] = useState([]);

  const getName = () => {
    return `<p>${form.garment.sf.arrangement_group.sf.arrangement.name.replace(
      /(<([^>]+)>)/gi,
      ""
    )} ${indexToShow}</p>`;
  };

  useEffect(() => {
    setOptions(
      form.withDiscount
        ? optionsAllowed.filter((o) => o.key.split("-").length === 3)
        : optionsAllowed.filter((o) => o.key.split("-").length === 2)
    );
  }, [optionsAllowed]);

  useEffect(() => {
    if (isHidden && form.withDiscount) {
      setPriceWithoutDiscount(0);
      setDiscount(0);
      setSelectValue(`${jPath}.arrangement_group[${index}].arrangement_group.priceWithoutDiscount.value`, 0);
      setSelectValue(`${jPath}.arrangement_group[${index}].arrangement_group.discount.value`, 0);
      setTimeout(() => {
        if (form.withDiscount) {
          setArrangementsPriceWithoutDiscount(updateArrangementsPriceWithoutDiscount());
          setArrangementsDiscount(updateArrangementsDiscount());
        }
      }, 200);
    }
  }, [isHidden]);

  return (
    <Fragment>
      <div className="arrangement_container" style={{ marginTop: index !== 0 ? "24px" : "8px" }}>
        <div className="field-creator__field-container tocalculate">
          <SelectFieldComboField
            register={register}
            setSelectValue={(name, value) => {
              const selectedPrice = value[0]
                ? parseFloat(value[0].split("-")[form.withDiscount ? 2 : 1]?.replace(",", "."))
                : [];
              setPrice(selectedPrice);
              setSelectValue(`${jPath}.arrangement_group[${index}].arrangement_group.price.value`, selectedPrice);

              if (form.withDiscount) {
                const selectedPriceWithoutDiscount = value[0]
                  ? parseFloat(value[0].split("-")[1]?.replace(",", "."))
                  : [];
                const selectedDiscount = Number.parseFloat(selectedPriceWithoutDiscount - selectedPrice).toFixed(2);
                setPriceWithoutDiscount(selectedPriceWithoutDiscount);
                setDiscount(selectedDiscount);
                setSelectValue(
                  `${jPath}.arrangement_group[${index}].arrangement_group.priceWithoutDiscount.value`,
                  selectedPriceWithoutDiscount
                );
                setSelectValue(
                  `${jPath}.arrangement_group[${index}].arrangement_group.discount.value`,
                  selectedDiscount
                );
              } else {
                setSelectValue(
                  `${jPath}.arrangement_group[${index}].arrangement_group.priceWithoutDiscount.value`,
                  selectedPrice
                );
                setSelectValue(`${jPath}.arrangement_group[${index}].arrangement_group.discount.value`, 0);
              }
              setTimeout(() => {
                setArrangementsPrice(updateArrangementsPrice());
                if (form.withDiscount) {
                  setArrangementsPriceWithoutDiscount(updateArrangementsPriceWithoutDiscount());
                  setArrangementsDiscount(updateArrangementsDiscount());
                }
                setSelectValue(name, value);
              }, 200);
            }}
            name={getName()}
            path={`${jPath}.arrangement_group[${index}].arrangement_group.arrangement`}
            selOptions={options}
            errors={errors}
            setOnFocus={setOnFocus}
            isHidden={isHidden}
            hasPriceDiscount={form.withDiscount}
          />
        </div>
        <div className="field-creator__field-container">
          <MediaField
            name={`${form.garment.sf.arrangement_group.sf.arrangement_images.name}`}
            path={`${jPath}.arrangement_group[${index}].arrangement_group.arrangement_images`}
            setSelectValue={setSelectValue}
            register={register}
            errors={errors}
            index={index}
            windowSize={windowSize}
            isMobileBrowser={isMobileBrowser}
          />
        </div>
        <div className="fix_add_margin">
          <TextInput
            name={form.garment.sf.arrangement_group.sf.message.name}
            path={`${jPath}.arrangement_group[${index}].arrangement_group.message.value`}
            register={register}
            errors={errors}
            setOnFocus={setOnFocus}
          />
          {/* <TextAreaField
            name={form.garment.sf.arrangement_group.sf.message.name}
            path={`${jPath}.arrangement_group[${index}].arrangement_group.message`}
            register={register}
            setSelectValue={setSelectValue}
            errors={errors}
          /> */}
        </div>
        <div style={{ display: "none" }}>
          <TextInput
            name={form.garment.sf.arrangement_group.sf.price.name}
            path={`${jPath}.arrangement_group[${index}].arrangement_group.price.value`}
            register={register}
            errors={errors}
            defaultValue={price}
            setOnFocus={setOnFocus}
          />
          <TextInput
            name={form.garment.sf.arrangement_group.sf.priceWithTaxes.name}
            path={`${jPath}.arrangement_group[${index}].arrangement_group.priceWithTaxes.value`}
            register={register}
            errors={errors}
            defaultValue={price}
            setOnFocus={setOnFocus}
          />
          <TextInput
            name={form.garment.sf.arrangement_group.sf.priceWithoutDiscount.name}
            path={`${jPath}.arrangement_group[${index}].arrangement_group.priceWithoutDiscount.value`}
            register={register}
            errors={errors}
            defaultValue={priceWithoutDiscount}
            setOnFocus={setOnFocus}
            className="to-calculate-price-without-discount"
          />
          <TextInput
            name={form.garment.sf.arrangement_group.sf.discount.name}
            path={`${jPath}.arrangement_group[${index}].arrangement_group.discount.value`}
            register={register}
            errors={errors}
            defaultValue={discount}
            setOnFocus={setOnFocus}
            className="to-calculate-discount"
          />
        </div>
        <div className="transport_delete_info-container">
          {isLast && (
            <div className="arrangement__add-arrangement" onClick={() => addItem()}>
              <p>+ {translate("repair.add")}</p>
            </div>
          )}
          <div className="transport_delete_info" style={{ visibility: index !== 0 ? "visible" : "hidden" }}>
            <button
              className="transport_delete-text"
              onClick={() => {
                if (index !== 0) {
                  deleteItem();
                }
              }}
            >
              {translate("repair.delete")}
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

Arrangement.defaultProps = {
  optionsAllowed: [],
};

export default Arrangement;
